export default __webpack_public_path__ + "dist/media/Invite-and-track.2a867f83.svg";